import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { CONSULTATION_TYPES, URLS, USER_TYPES } from 'src/app/constant/constant';
import { fetchAllData } from 'src/app/models/Doctor';
import { ApiResult, PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { NewConsultationWorkflow, Nutrition_Health_Consultation_Plans_List } from 'src/app/models/consultdoctors';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { ConsultationStatusModel, PackageStatusModel } from 'src/app/models/package';
import { AuthService } from 'src/app/services/auth.service';
import { CountriesService } from 'src/app/services/countries.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { PatientService } from 'src/app/services/patient.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { DateUtilService, moment_duration } from 'src/app/utilities/date.util.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { setUser as setSentryUser, TraceClassDecorator } from '@sentry/angular';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { UserService } from 'src/app/services/user.service';
import { RefferalDiscountService } from 'src/app/services/refferal-discount.service';
import { PaymentSuccessResult, Payment_Data, order_model } from 'src/app/models/basket';
import { GeocoderResponse, OtpData } from 'src/app/models/util.models';
import { ConsultationFlowPaymentComponent } from '../../shared/consultation-flow-payment/consultation-flow-payment.component';
import { GeocodingService } from 'src/app/services/geeocoding.google.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { filter } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language.service'; // Import LanguageService
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';


export enum CONSULTATION_FORMS_TABS {
  BASIC_FORM = 0,
  LOGIN = 1,
  REGISTER = 2,
  CONFIRM_PAY = 3,
  PAYMENT_FORMS = 4,
  PAYMENT_SUCCESS = 5,
}

@TraceClassDecorator()
@Component({
  selector: 'app-consultation-flow',
  templateUrl: './consultation-flow.component.html',
  styleUrls: ['./consultation-flow.component.css']
})
export class ConsultationFlowComponent implements OnInit, OnDestroy {
  terms_and_conditions_url: string = this.utilitiesService.getBaseUrl('HOMPAGE_BASE_URL') + 'terms-of-use';
  max_date: Date = this.utilitiesService.getMaxDate();
  is_uk_country: boolean = false;
  consultationWorkflowData: NewConsultationWorkflow = new NewConsultationWorkflow(this.terms_and_conditions_url, this.max_date);
  logo_url: string = '';
  provider_id: string = "";
  slug: string = "";
  buttonConfigs = [
    { label: 'Next 1', action: async () => await this.phoneExists() },
    { label: 'Next 2', action: async () => await this.otpVerifySubmit() },
    { label: 'Next 3', action: async () => await this.otpVerifySubmit_register() },
    { label: 'Next 4', action: async () => await this.submitConsultationForm() },
  ];
  @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;
  @ViewChild(ConsultationFlowPaymentComponent) payment_screen: ConsultationFlowPaymentComponent;

  languageOptions: { code: string, name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'fr', name: 'French' },
    { code: 'ar', name: 'Arabic'},
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'de', name: 'German' },
    { code: 'mr', name: 'Marathi' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'te', name: 'Telugu' },
    { code: 'ta', name: 'Tamil' },
    { code: 'bn', name: 'Bengali' },
    { code: 'ur', name: 'Urdu' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'kn', name: 'Kannada' },
    { code: 'or', name: 'Oriya' },
    { code: 'ne', name: 'Nepali' }
  ];

  selectedLanguage: string = 'en'; // Default language

  navigationSubscription: Subscription;

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly route: ActivatedRoute,
    private readonly specialtyService: SpecialityService,
    private readonly patientService: PatientService,
    private readonly doctorService: DoctorsService,
    private readonly countriesService: CountriesService,
    private readonly dateUtilService: DateUtilService,
    private readonly authService: AuthService,
    private readonly changeDetector: ChangeDetectorRef,
    private recaptchaV3Service: ReCaptchaV3Service,
    private readonly userService: UserService,
    private readonly refferalDiscountService: RefferalDiscountService,
    private router: Router,
    private readonly geocodingService: GeocodingService,
    private readonly providerStateService: ProviderStateService,
    private readonly translateService: GoogleTranslateService,
    private readonly languageService: LanguageService
  ) {
  }

  async ngOnInit(): Promise<void> {
    // sessionStorage.clear();
    this.slug = this.providerStateService.getProviderSlug();
    this.provider_id = this.providerStateService.getProviderId();
    if (URLS.IS_UK) {
      this.is_uk_country = true;
    }
    this.terms_and_conditions_url = this.utilitiesService.getBaseUrl('HOMPAGE_BASE_URL') + 'terms-of-use';
    this.max_date = this.utilitiesService.getMaxDate();
    this.consultationWorkflowData = new NewConsultationWorkflow(this.terms_and_conditions_url, this.max_date);
    // this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id = CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION;
    if (this.is_uk_country) {
      this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id =
        CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION;
    }
    else {
      this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id =
        CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION;
    }
    await this.onConsultationChange();
    await this.setConsultationType();
    await this.getCountries();
    await this.getCurrentLocation();
    this.navigationSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async () => {
        await this.onConsultationChange();
        await this.setConsultationType();
        await this.getCountries();
        await this.getCurrentLocation();
      });
    this.initializeLanguage();
  }


  async setCountry(country_code: string) {
    if (country_code in this.consultationWorkflowData.countries_code_2) {
      this.consultationWorkflowData.patientreg.other_data.selected_country_data = this.consultationWorkflowData.countries_code_2[country_code];
      this.consultationWorkflowData.patientreg.other_data.selected_country_acronym = this.consultationWorkflowData.patientreg.other_data.selected_country_data.acronym;
      await this.onChangeCountry();
    }
  }

  async getCurrentLocation() {
    let location_api_result: GeocoderResponse = new GeocoderResponse("", []);
    let user_country: string = localStorage.getItem("user_country");
    if (user_country != null) {
      this.setCountry(user_country);
    }
    else {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const point: google.maps.LatLngLiteral = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          await this.geocodingService.geocodeLatLng(point)
            .then((response: GeocoderResponse) => {
              if (response.status === 'OK' && response.data?.length) {
                let country_code = null;
                response.data.forEach(element => {
                  if (element.types.includes('country')) {
                    // Find the country code in the address components
                    const countryCodeComponent = element.address_components.find(component => component.types.includes('country'));
                    if (countryCodeComponent) {
                      // Extract the country code from the address component
                      country_code = countryCodeComponent.short_name;
                    }
                  }
                });

                // Set the country code
                this.setCountry(country_code);

                // Save the country code in localStorage if needed
                localStorage.setItem("user_country", country_code);
              } else {
                location_api_result.success = false;
                location_api_result = response
                return location_api_result;
              }
            })
        },
        (error) => {
          location_api_result.error.message = "Couldn't get your location";
          location_api_result.success = false;
          if (error.PERMISSION_DENIED) {
            location_api_result.error.code = 'PERMISSION_DENIED';
          } else if (error.POSITION_UNAVAILABLE) {
            location_api_result.error.code = 'POSITION_UNAVAILABLE';
          } else if (error.TIMEOUT) {
            location_api_result.error.code = 'POSITION_TIMEOUT';
          } else {
            location_api_result.error.code = "UNKNOWN-" + error.code;
            location_api_result.error.message = error.message;
          }
          return location_api_result;
        },
        { enableHighAccuracy: true }
      );
    }
  }

  editPhoneNumber() {
    this.consultationWorkflowData.edit_phone_no = true;
  }

  async getCountries(): Promise<void> {
    await this.countriesService
      .getCountries(this.provider_id)
      .toPromise()
      .then(async (countries) => {
        countries.forEach((ele) => {
          ele["final_value"] = ele.acronym,
            ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
          let country_data: CountrySelectedValue = {
            id: Number(ele.id),
            acronym: ele.acronym,
            is_national_license: ele.is_national_license,
            phone_code: '+' + String(ele.phone_code),
            country_name: ele.country_name
          };
          this.consultationWorkflowData.countries_code_3[ele.acronym] = country_data;
          this.consultationWorkflowData.countries_code_2[ele.iso_3166_1_aplha_2] = country_data;
        });
        this.consultationWorkflowData.patientreg.other_data.countries = this.utilitiesService.getSelectItemList(countries, "final_label_string", "final_value");
      }).catch((err) => {
        console.error(err);
      });
  }

  async onChangeCountry() {
    this.consultationWorkflowData.patientreg.other_data.selected_country_data = this.consultationWorkflowData.countries_code_3[this.consultationWorkflowData.patientreg.other_data.selected_country_acronym];
    await this.countriesService
      .getStates(this.consultationWorkflowData.patientreg.other_data.selected_country_data?.id)
      .toPromise()
      .then((states) => {
        this.consultationWorkflowData.patientreg.other_data.states = this.utilitiesService.getSelectItemList(states, "state_name", "id");
      }).catch((err) => {
        console.error(err);
      });
  }

  async openLink(link: string): Promise<void> {
    await this.router.navigate(['/' + this.slug + '/' + link]);
  }

  async openBaseLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }

  async setSpeciality() {
    this.route.queryParamMap.subscribe(async (res) => {
      if (res.get('common_health_id')) {

        // this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id = CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION;
        if (this.is_uk_country) {
          this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id =
            CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION;
        }
        else {
          this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id =
            CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION;
        }
        await this.getSpecialty(this.consultationWorkflowData.consultation_data.consultApiData.patient_guid, parseInt(res.get('common_health_id')), this.provider_id);
      }
      else await this.getSpecialty(this.consultationWorkflowData.consultation_data.consultApiData.patient_guid, undefined, this.provider_id);
    });
  }

  async getDietPreference(): Promise<void> {
    this.consultationWorkflowData.consultation_data.other_data.diet_preference_list_api_result = new ApiResult(true);
    await this.patientService
      .getDietPreference()
      .toPromise()
      .then((result) => {
        this.consultationWorkflowData.consultation_data.other_data.diet_preference_list_api_result.PromiseResult = result;
        if (result.success) {
          this.consultationWorkflowData.consultation_data.other_data.dietPreferenceData = this.utilitiesService.getSelectItemList(result.data.diet_types, "diet_type", "id", false);
        }
        this.consultationWorkflowData.consultation_data.other_data.diet_preference_list_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.diet_preference_list_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.diet_preference_list_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.diet_preference_list_api_result.Posting = false;
      });
  }

  set_otp_data(result: PromiseResult) {
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.user_guid = result.data.user_guid;
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.service_id = result.data.service_id;
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
  }

  async register_or_resend_otp() {
    this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result = new ApiResult(true);
    this.consultationWorkflowData.patientreg.api_data.userPatientv2 = {
      ...this.consultationWorkflowData.patientreg.api_data.userPatientv2,
      ...this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api
    }
    this.consultationWorkflowData.patientreg.api_data.userPatientv2.provider_id = this.providerStateService.getProviderId();
    await this.userService
      .register_or_resend_otp_patient(this.consultationWorkflowData.patientreg.api_data.userPatientv2)
      .toPromise()
      .then(async (result) => {
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.PromiseResult = result;
        if (result.success) {
          if (this.consultationWorkflowData.patientreg.api_data.userPatientv2.retry) {
            // this.set_otp_register_data(result);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
            this.set_otp_data(result);
            this.changeDetector.detectChanges();
            this.OTP_Input.init_countdown();
          }
          else {
            this.login_set_data(result);
            await this.confirmPay();
          }
        }
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.ServerError = error.error;
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.Posting = false;
      })
  }

  async confirmPay() {
    this.consultationWorkflowData.consultation_data.other_data.members_list_api_result = new ApiResult(false);
    this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result = new ApiResult(false);
    this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result = new ApiResult(false);
    this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result = new ApiResult(false);
    this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result = new ApiResult(false);
    await this.setSpeciality();
    await this.getMemberList();
    await this.onConsultationChange();
    // await this.onSpecialityChange();
    this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.CONFIRM_PAY;
  }

  async login_validate_or_resend_otp() {
    this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result = new ApiResult(true);
    await this.authService
      .login_validate_or_resend_otp_patient(this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api)
      .toPromise()
      .then(async (result) => {
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.PromiseResult = result;
        if (result.success) {
          if (this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.retry) {
            this.set_otp_data(result);
            this.changeDetector.detectChanges();
            this.OTP_Input.init_countdown();
          }
          else {
            this.login_set_data(result);
            await this.confirmPay();
          }
        }
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.ServerError = error.error;
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.Posting = false;
      })
  }

  login_set_data(result: PromiseResult) {
    sessionStorage.setItem('userid', result.data.userid);
    sessionStorage.setItem('authtoken', result.data.authtoken);
    sessionStorage.setItem('refresh', "true");
    sessionStorage.setItem('refresh_token', result.data.refreshToken);
    sessionStorage.setItem('email', 'default');
    sessionStorage.setItem('name', 'default');
    setSentryUser({
      email: this.consultationWorkflowData.patientreg.other_data.selected_country_data.phone_code + this.consultationWorkflowData.patientreg.other_data.primary_contact_no,
      id: result.data.userid,
      role: USER_TYPES.PATIENT
    });
    //Todo: need to change this based on role
    // this.setUser(this.login_data.auth_result);
  }

  async otp_resend() {
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.retry = true;
    await this.login_validate_or_resend_otp();
  }

  async otpVerifySubmit() {
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.retry = false;
    await this.login_validate_or_resend_otp();
  }

  async otp_resend_register() {
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.retry = true;
    await this.register_or_resend_otp();
  }

  async otpVerifySubmit_register() {
    this.consultationWorkflowData.patientreg.api_data.otp_data.OTP_validate_api.retry = false;
    await this.register_or_resend_otp();
  }

  async phoneExists(): Promise<void> {
    this.consultationWorkflowData.phones_exists_response = new ApiResult(true);
    this.consultationWorkflowData.patientreg.api_data.otp_data = new OtpData(0);
    await this.recaptchaV3Service.execute('recaptchaResolve')
      .toPromise().then((token: string) => {
        if (token != null) {
          this.consultationWorkflowData.patientreg.api_data.userPatientv2.recaptcha = token;
        }
        else {
          let serverError: ServerError = new ServerError();
          serverError = {
            statusCode: 400,
            error: "Invalid rcaptcha token",
            message: "Invalid rcaptcha token"
          }
          this.consultationWorkflowData.phones_exists_response.ServerError = serverError;
          this.consultationWorkflowData.phones_exists_response.PromiseResult.success = false;
          this.consultationWorkflowData.phones_exists_response.Posting = false;
          return;
        }
      });
    this.consultationWorkflowData.phone_exists_api_data = {
      primary_contact_number: this.consultationWorkflowData.patientreg.other_data.selected_country_data.phone_code + this.consultationWorkflowData.patientreg.other_data.primary_contact_no,
      recaptcha: this.consultationWorkflowData.patientreg.api_data.userPatientv2.recaptcha
    }

    await this.authService
      .phone_exists(this.consultationWorkflowData.phone_exists_api_data)
      .toPromise()
      .then((result) => {
        this.consultationWorkflowData.phones_exists_response.PromiseResult = result;
        if (result.success) {
          if (result.data.is_new_user) {
            // this.set_otp_register_data(result);
            this.set_otp_data(result);
            this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.REGISTER;
            this.set_register_data();
          }
          else {
            this.set_otp_data(result);
            this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.LOGIN;
          }
          this.changeDetector.detectChanges();
          this.OTP_Input.init_countdown();
          this.consultationWorkflowData.edit_phone_no = false;
        }
        this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result = new ApiResult(false);
        this.consultationWorkflowData.phones_exists_response.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.phones_exists_response.ServerError = error.error;
        this.consultationWorkflowData.phones_exists_response.PromiseResult.success = false;
        this.consultationWorkflowData.phones_exists_response.Posting = false;
      });
  }

  async getMemberList(): Promise<void> {
    this.consultationWorkflowData.consultation_data.other_data.members_list_api_result = new ApiResult(true);
    await this.patientService
      .getMember(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result) => {
        this.consultationWorkflowData.consultation_data.other_data.members_list_api_result.PromiseResult = result;
        if (result.success) {
          result.data.patient.forEach(ele => {
            ele.full_name = ele.first_name + " " + (ele.middle_name == null ? '' : ele.middle_name) + " " + ele.last_name;
            this.consultationWorkflowData.consultation_data.patient_state[ele.patient_guid] = ele.state_id;
            // this.consultationWorkflowData.consultation_data.other_data.patient_profile_complete[ele.patient_guid] = ele.profile_complete;
            this.consultationWorkflowData.consultation_data.other_data.patient_country_map[ele.patient_guid] = ele.country_id;
          });

          this.consultationWorkflowData.consultation_data.other_data.members_data = this.utilitiesService.getSelectItemList(result.data.patient, "full_name", "patient_guid", false);
          if (this.consultationWorkflowData.consultation_data.other_data.members_data.length > 0) {
            this.consultationWorkflowData.consultation_data.consultApiData.patient_guid = this.consultationWorkflowData.consultation_data.other_data.members_data[0].value;
          }
        }
        this.consultationWorkflowData.consultation_data.other_data.members_list_api_result.Posting = false;

        //this.selectedMember=result.data.patient[0];
      }).catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.members_list_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.members_list_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.members_list_api_result.Posting = false;
      });
  }

  async submitConsultationForm() {
    await this.submitConsultation();
  }

  async submitConsultation(): Promise<void> {
    this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result = new ApiResult(true);
    this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result = new ApiResult(true);
    // for normal consultation ui will handle slot bdoctor choose
    // only for preferred slot this slot doctor choose will set 
    this.consultationWorkflowData.consultation_data.setSlotDoctorChoose();
    this.consultationWorkflowData.consultation_data.other_data.payment_data = new Payment_Data();
    this.consultationWorkflowData.consultation_data.consultApiData.additional_offers =
      (this.consultationWorkflowData.consultation_data.other_data.selected_additional_offer != null)
        ? [this.consultationWorkflowData.consultation_data.other_data.selected_additional_offer]
        : [];
    if (this.isNutritionAndHealthConsultation()) {
      // form backend its going to change the specialty id during api call so sending random value
      this.consultationWorkflowData.consultation_data.consultApiData.specialty_id = [1];
    }
    await this.patientService
      .consultDoctor(this.consultationWorkflowData.consultation_data.consultApiData)
      .toPromise()
      .then(async (result) => {
        this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result.PromiseResult = result;
        if (result.success) {
          this.consultationWorkflowData.consultation_data.other_data.payment_data.stripe_checkout_url = result.data.stripe_checkout_url;
          if (result.data.consultation_request_number == null) {
            const order: order_model = result.data;
            this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result.PromiseResult = result;
            this.consultationWorkflowData.consultation_data.other_data.payment_data.order_data = order;
            await this.start_payment();
            this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.PAYMENT_FORMS
            // this.consultationWorkflowData.consultation_data.other_data.tabview_Data.nextTab(CONSULTATION_FORMS_TABS.PAYMENT_FORMS);
          }
          else {
            this.consultationWorkflowData.consultation_data.other_data.payment_data.paymentSuccessData.consultationData.consultation_request_number = result.data.consultation_request_number;
            this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.PAYMENT_SUCCESS;
            // this.consultationWorkflowData.consultation_data.other_data.tabview_Data.nextTab(CONSULTATION_FORMS_TABS.PAYMENT_SUCCESS);
          }
        }
        this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result.Posting = false;
        this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result.Posting = false;
      }).catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.submit_consultation_api_result.Posting = false;
        this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.payment_data.payment_start_api_result.Posting = false;
      });
  }

  onPaymentSuccess(data: PaymentSuccessResult) {
    this.consultationWorkflowData.consultation_data.other_data.payment_data.paymentSuccessData = data;
    this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.PAYMENT_SUCCESS;
  }

  async start_payment() {
    this.changeDetector.detectChanges();
    await this.payment_screen.load_payment_gateway();
  }

  isPackageSpecialty(): boolean {
    return this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.specialtyHide;
  }

  async discountCodeBtn() {
    if (this.consultationWorkflowData.consultation_data.other_data.discount_applied) {
      this.consultationWorkflowData.consultation_data.other_data.discount_applied = false;
      this.consultationWorkflowData.consultation_data.consultApiData.discount_id = null;
      this.consultationWorkflowData.consultation_data.other_data.coupon_code_data.discount_code_api.discount_code = '';
    } else {
      await this.applyDiscount();
    }
  }

  async applyDiscount() {
    this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result = new ApiResult(true);
    this.consultationWorkflowData.consultation_data.other_data.discount_applied = false;
    this.consultationWorkflowData.consultation_data.other_data.coupon_code_data.discount_code_api.patient_guid = this.consultationWorkflowData.consultation_data.consultApiData.patient_guid;
    await this.refferalDiscountService
      .applyDiscountCodeAtConsultation(this.consultationWorkflowData.consultation_data.other_data.coupon_code_data.discount_code_api)
      .toPromise()
      .then((result) => {
        this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result.PromiseResult = result;
        if (result.success) {
          this.consultationWorkflowData.consultation_data.consultApiData.discount_id = result.data.discount_id;
          this.consultationWorkflowData.consultation_data.other_data.discount_applied = true;
          this.consultationWorkflowData.consultation_data.other_data.discount_message = "The Code Has Been Applied Successfully, Click Continue to Payment to get more information";
        }
        else {
          this.consultationWorkflowData.consultation_data.other_data.coupon_code_data.discount_code_api.discount_code = '';
        }
        this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result.Posting = false;
      }).catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.discount_code_apply_api_result.Posting = false;
      });
  }

  async onMemberChange() {
    await this.onDataChange();
  }

  isPay(): boolean {
    return this.consultationWorkflowData.consultation_data.other_data.is_pay;
  }

  async onUserPackageChange() {
    await this.getPriorityList();
  }

  text(data: ConsultationStatusModel[]) {
    let text = [];
    data.forEach(ele => {
      text.push(ele.current_count + " consultation left");
    });
    return text.toString();
  }

  async onPaymentChange() {
    this.consultationWorkflowData.consultation_data.resetPackagesDisabled();
    if (this.isPay()) {
      this.consultationWorkflowData.consultation_data.reset_user_package_id();
      this.consultationWorkflowData.consultation_data.other_data.is_package_diet = false;
    }
    else {
      //note this assumes that we only have one package at a time
      this.consultationWorkflowData.consultation_data.consultApiData.user_package_id = this.consultationWorkflowData.consultation_data.other_data.packages_status_data[0].id;
      this.setPackageOtherData(this.consultationWorkflowData.consultation_data.other_data.packages_status_data[0]);
    }
    await this.getPriorityList();
  }

  set_register_data() {
    this.consultationWorkflowData.patientreg.api_data.userPatientv2.country_id = this.consultationWorkflowData.patientreg.other_data.selected_country_data.id;
    this.consultationWorkflowData.patientreg.api_data.userPatientv2.primary_contact_number = this.consultationWorkflowData.patientreg.other_data.selected_country_data.phone_code + this.consultationWorkflowData.patientreg.other_data.primary_contact_no;
  }

  isPosting(): boolean {
    return this.consultationWorkflowData.phones_exists_response.Posting ||
      this.consultationWorkflowData.patientreg.api_data.otp_data.otp_api_result.Posting;
  }

  async openInvoice() {
    this.consultationWorkflowData.consultation_data.other_data.print_data.api_result = new ApiResult(true)
    this.consultationWorkflowData.consultation_data.other_data.print_data.displayModal = true;
    await this.patientService
      .fetchInvoice(this.consultationWorkflowData.consultation_data.other_data.payment_data.paymentSuccessData.consultationData.transaction_id)
      .toPromise()
      .then((result) => {
        this.consultationWorkflowData.consultation_data.other_data.print_data.api_result.PromiseResult = result;
        if (result.success) {
          this.consultationWorkflowData.consultation_data.other_data.print_data.data = result.data;
        }
        else {
          this.consultationWorkflowData.consultation_data.other_data.print_data.api_result.ErrorModel = result.error;
        }
        this.consultationWorkflowData.consultation_data.other_data.print_data.api_result.Posting = false;
      }).catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.print_data.api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.print_data.api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.print_data.api_result.Posting = false;
      });
  }

  print() {
    window.print();
  }

  async getDietitionList(): Promise<void> {
    this.consultationWorkflowData.consultation_data.other_data.dietition_list_api_result = new ApiResult(true);
    let data: fetchAllData = new fetchAllData();
    data.is_diet = true;
    data.provider_id = this.provider_id;
    await this.doctorService
      .getFetchAllActiveUsers(data)
      .toPromise()
      .then((result) => {
        this.consultationWorkflowData.consultation_data.other_data.dietition_list_api_result.PromiseResult = result;
        if (result.success) {
          result.data.data.forEach(ele => {
            ele.full_name = ele.first_name + " " + (ele.middle_name == null ? '' : ele.middle_name) + " " + ele.last_name;
          });
          this.consultationWorkflowData.consultation_data.other_data.preferredDieticianData = this.utilitiesService.getSelectItemList(result.data.data, "full_name", "user_guid", false);
        }
        this.consultationWorkflowData.consultation_data.other_data.dietition_list_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.dietition_list_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.dietition_list_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.dietition_list_api_result.Posting = false;
      });
  }

  async setConsultationType() {
    this.route.queryParamMap.subscribe((res) => {
      if (res.get('consultation_type_id'))
        this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id = parseInt(res.get('consultation_type_id'))
    });
    if (Boolean(this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id)) {
      await this.onConsultationChange();
    }
  }

  async onConsultationChange() {
    await this.onDataChange();
  }

  async onDataChange() {
    // need to reset values so adding the common consultaion and member changes function 
    // this.consultationWorkflowData.consultation_data.resetSpecialties();
    this.consultationWorkflowData.consultation_data.resetSelectedDietPlan();
    this.consultationWorkflowData.consultation_data.resetFollowUpConultationID();
    this.consultationWorkflowData.consultation_data.consultApiData.is_followup = this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id === this.consultationWorkflowData.consultation_data.const_data.CONSULTATION_TYPES.FOLLOW_UP_CONSULTATION;
    if (this.isFollowUp()) {
      await this.getFollowUpConsultations();
    }
    else {
      this.consultationWorkflowData.consultation_data.consultApiData.followup_consultation_id = 1;
    }
    await this.getPackages();
    await this.getPriorityList();
    await this.getSpecialty(this.consultationWorkflowData.consultation_data.consultApiData.patient_guid, undefined, this.provider_id);
  }

  async getFollowUpConsultations() {
    if (this.consultationWorkflowData.consultation_data.consultApiData.patient_guid) {
      let close_consultation_data: SelectItem[] = [];
      this.consultationWorkflowData.consultation_data.other_data.closed_consultation_list_api_result = new ApiResult(true);
      await this.patientService
        .getClosedConsultation(this.consultationWorkflowData.consultation_data.consultApiData.patient_guid)
        .toPromise()
        .then((result) => {
          this.consultationWorkflowData.consultation_data.other_data.closed_consultation_list_api_result.PromiseResult = result;
          if (result.success) {
            close_consultation_data = this.utilitiesService.getSelectItemList(result.data, "consultation_request_number", "", false);

          }
          this.consultationWorkflowData.consultation_data.other_data.closed_consultation_list_api_result.Posting = false;
        }).catch((error: HttpErrorResponse) => {
          this.consultationWorkflowData.consultation_data.other_data.closed_consultation_list_api_result.ServerError = error.error;
          this.consultationWorkflowData.consultation_data.other_data.closed_consultation_list_api_result.PromiseResult.success = false;
          this.consultationWorkflowData.consultation_data.other_data.closed_consultation_list_api_result.Posting = false;
        });
      this.consultationWorkflowData.consultation_data.other_data.close_consultation_data = close_consultation_data;
    }
  }

  async getPackages() {
    this.consultationWorkflowData.consultation_data.reset_pay_data();
    this.consultationWorkflowData.consultation_data.reset_package_status_data();
    this.consultationWorkflowData.consultation_data.reset_user_package_id();
    // this.consultationWorkflowData.consultation_data.resetPackageData();
    if (this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id != null && this.consultationWorkflowData.consultation_data.consultApiData.patient_guid != null) {
      this.consultationWorkflowData.consultation_data.other_data.user_packages_list_api_result = new ApiResult(true);
      this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.apiData = {
        patient_guid: this.consultationWorkflowData.consultation_data.consultApiData.patient_guid,
        consultation_type_id: this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id
      }

      await this.patientService
        .findPackages(this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.apiData)
        .toPromise()
        .then((result) => {
          this.consultationWorkflowData.consultation_data.other_data.user_packages_list_api_result.PromiseResult = result;
          if (result.success) {
            this.consultationWorkflowData.consultation_data.other_data.packages_status_data = result.data.packages;
            if (this.consultationWorkflowData.consultation_data.other_data.packages_status_data.length > 0) {
              this.consultationWorkflowData.consultation_data.other_data.is_pay = false;
              this.consultationWorkflowData.consultation_data.other_data.packages_status_data.forEach((ele, index) => {
                let final_name: string = ele.package_type.package_name;
                final_name = final_name.split("(N/A)")[0];
                ele.final_name = final_name
              });
              this.consultationWorkflowData.consultation_data.consultApiData.user_package_id = this.consultationWorkflowData.consultation_data.other_data.packages_status_data[0].id;
              this.setPackageOtherData(this.consultationWorkflowData.consultation_data.other_data.packages_status_data[0]);
            }
          }
          this.consultationWorkflowData.consultation_data.other_data.user_packages_list_api_result.Posting = false;
        }).catch((error: HttpErrorResponse) => {
          this.consultationWorkflowData.consultation_data.other_data.user_packages_list_api_result.ServerError = error.error;
          this.consultationWorkflowData.consultation_data.other_data.user_packages_list_api_result.PromiseResult.success = false;
          this.consultationWorkflowData.consultation_data.other_data.user_packages_list_api_result.Posting = false;
        });
    }
  }

  setPackageOtherData(data: PackageStatusModel) {
    const data_upc: ConsultationStatusModel = data.user_package_count[0];
    if (data.package_type.vendor_guid != null) {
      this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.consultationDisabled = true;
      this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id = data_upc.consultation_type_id;
    }

    if (data_upc.specialty_id != null) {
      this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.specialtyHide = true;
      this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.specialty_name = data_upc.d_specialty_type.specialty_name;
      this.consultationWorkflowData.consultation_data.other_data.selectedSpecialtyId = data_upc.specialty_id;
      this.consultationWorkflowData.consultation_data.consultApiData.specialty_id = [data_upc.specialty_id];
    }

    if (data_upc.priority_type_id != null) {
      this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.priorityDisabled = true;
      this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.priority_type_id = data_upc.priority_type_id;
    }

    this.consultationWorkflowData.consultation_data.other_data.slotsFetch.api_data.vendor_guid = data.package_type.vendor_guid;
    this.consultationWorkflowData.consultation_data.other_data.slotsFetch.other_data.is_display = (data.package_type.vendor_guid != null);
    // this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.packagesDiabled = (data.package_type.vendor_guid != null)

    if (this.consultationWorkflowData.consultation_data.other_data.slotsFetch.other_data.is_display) {
      this.consultationWorkflowData.consultation_data.consultApiData.slot_doctor_choose = false;
    }

    if (this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id == CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION) {
      this.consultationWorkflowData.consultation_data.other_data.is_package_diet = true;
    }
  }

  async getSpecialty(patient_guid: string, common_health_id?: number, provider_id?: string) {
    this.consultationWorkflowData.consultation_data.other_data.specialty_list_api_result = new ApiResult(true);
    await this.specialtyService
      .GetAllSupportedPatient(patient_guid, common_health_id, provider_id)
      .toPromise()
      .then(async (result) => {
        this.consultationWorkflowData.consultation_data.other_data.specialty_list_api_result.PromiseResult = result;
        // const sp: SupportedSpecialty[] = result.data
        if (result.success) {
          this.consultationWorkflowData.consultation_data.other_data.specialty_data = this.utilitiesService.getSelectItemList(result.data, "specialty_name", "id", false);
          if (this.consultationWorkflowData.consultation_data.other_data.specialty_data.length == 1) {
            this.consultationWorkflowData.consultation_data.other_data.selectedSpecialtyId = this.consultationWorkflowData.consultation_data.other_data.specialty_data[0].value;
            await this.onSpecialityChange();
          }
        }
        this.consultationWorkflowData.consultation_data.other_data.specialty_list_api_result.Posting = false;
      }).catch((error: HttpErrorResponse) => {
        this.consultationWorkflowData.consultation_data.other_data.specialty_list_api_result.ServerError = error.error;
        this.consultationWorkflowData.consultation_data.other_data.specialty_list_api_result.PromiseResult.success = false;
        this.consultationWorkflowData.consultation_data.other_data.specialty_list_api_result.Posting = false;
      });
  }

  async onSpecialityChange() {
    switch (this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id) {
      case this.consultationWorkflowData.consultation_data.const_data.CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION:
        this.consultationWorkflowData.consultation_data.consultApiData.specialty_id = [this.consultationWorkflowData.consultation_data.other_data.selectedSpecialtyId];
        // await this.getPriorityList();
        break;
      case this.consultationWorkflowData.consultation_data.const_data.CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION:
        this.consultationWorkflowData.consultation_data.consultApiData.specialty_id = [this.consultationWorkflowData.consultation_data.other_data.selectedSpecialtyId];
        // await this.getPriorityList();
        break;
      default:
        break;
    }
  }

  async getPriorityList(): Promise<void> {
    this.consultationWorkflowData.consultation_data.resetPriorityID();
    if (
      this.consultationWorkflowData.consultation_data.consultApiData.patient_guid &&
      this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id > 0
    ) {
      this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result = new ApiResult(true);
      this.consultationWorkflowData.consultation_data.resetPriorityList();

      await this.patientService
        .getPriorityByGuid(
          this.consultationWorkflowData.consultation_data.consultApiData.patient_guid,
          this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id,
          this.consultationWorkflowData.consultation_data.other_data.selectedSpecialtyId,
          this.consultationWorkflowData.consultation_data.consultApiData.user_package_id
        )
        .toPromise()
        .then(async result => {
          this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result.PromiseResult = result;
          if (result.success) {
            this.consultationWorkflowData.consultation_data.other_data.priority_list = result.data.priority;
            this.consultationWorkflowData.consultation_data.other_data.offers = result.data.additional_offers;
            this.consultationWorkflowData.consultation_data.other_data.priority_list.forEach((ele) => {
              ele.price_label = ele.p_priority_doctor_origin.country.country_name + '( ' + this.renderAmount(ele.amount, ele.country.currency_type) + ' )';
              ele.no_price_label = ele.p_priority_doctor_origin.country.country_name;
            });
            if (this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.priorityDisabled)
              this.consultationWorkflowData.consultation_data.consultApiData.priority_type_id = this.consultationWorkflowData.consultation_data.other_data.packageConsultDoctor.otherData.priority_type_id;
            else
              this.consultationWorkflowData.consultation_data.consultApiData.priority_type_id = this.consultationWorkflowData.consultation_data.other_data.priority_list[0].id;
            this.ResetSlots();
          }
          if (this.isNutritionAndHealthConsultation()) {
            await this.setDietData(result);
          }
          this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result.Posting = false;
        }).catch((error: HttpErrorResponse) => {
          this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result.ServerError = error.error;
          this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result.PromiseResult.success = false;
          this.consultationWorkflowData.consultation_data.other_data.priority_list_api_result.Posting = false;
        });
    }
  }

  goBack() {
    switch (this.consultationWorkflowData.currentScreenIndex) {
      case CONSULTATION_FORMS_TABS.LOGIN:
        this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.BASIC_FORM;
        break;
      case CONSULTATION_FORMS_TABS.REGISTER:
        this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.BASIC_FORM;
        break;
      case CONSULTATION_FORMS_TABS.CONFIRM_PAY:
        this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.BASIC_FORM;
        break;
      case CONSULTATION_FORMS_TABS.PAYMENT_FORMS:
        this.consultationWorkflowData.currentScreenIndex = CONSULTATION_FORMS_TABS.CONFIRM_PAY;
        break;
      default:
        break;
    }
  }

  toggleInput() {
    this.consultationWorkflowData.showInput = !this.consultationWorkflowData.showInput;
  }

  isMultiSpecialtyConsultation(): boolean {
    return this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id === this.consultationWorkflowData.consultation_data.const_data.CONSULTATION_TYPES.MULTI_SPECIALTY_CONSULTATION;
  }

  isFollowUp(): boolean {
    return this.consultationWorkflowData.consultation_data.consultApiData.is_followup;
  }

  ResetSlots() {
    this.consultationWorkflowData.consultation_data.clear_slots();
    this.setDates();
  }

  setDates() {
    this.consultationWorkflowData.consultation_data.other_data.minDays = this.dateUtilService.addQuantity(new Date(), 1, moment_duration.days);
    this.consultationWorkflowData.consultation_data.other_data.minDays = this.dateUtilService.getDateResettingTime(this.consultationWorkflowData.consultation_data.other_data.minDays);
    this.consultationWorkflowData.consultation_data.other_data.maxDays = this.dateUtilService.addQuantity(new Date(), 21, moment_duration.days);
    this.consultationWorkflowData.consultation_data.other_data.maxDays = this.dateUtilService.getDateResettingTime(this.consultationWorkflowData.consultation_data.other_data.maxDays);
  }

  isNutritionAndHealthConsultation(): boolean {
    return this.consultationWorkflowData.consultation_data.consultApiData.consultation_type_id === this.consultationWorkflowData.consultation_data.const_data.CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION;
  }

  async setDietData(result: PromiseResult) {
    let data: Nutrition_Health_Consultation_Plans_List[] = [];
    if (result.success) {
      if (result.data.priority.length > 0) {
        if (!this.consultationWorkflowData.consultation_data.other_data.is_package_diet) {
          result.data.priority.forEach((ele) => {
            let is_free = Number(ele.amount) == 0;
            data.push({
              amount: ele.amount,
              consultation_name: ele.consultation_name,
              description: ele.description,
              id: ele.id,
              image_url: ele.image_url,
              isFree: is_free,
              number_of_consultations: ele.number_of_consultations,
              raw_amount: ele.amount,
              value: {
                id: ele.id,
                isFree: is_free,
              },
            });
          });
        }
        else {
          let temp_data = [result.data.priority[0]]
          temp_data.forEach((ele) => {
            let is_free = Number(ele.amount) == 0;
            data.push({
              amount: ele.amount,
              consultation_name: ele.consultation_name,
              description: ele.description,
              id: ele.id,
              image_url: ele.image_url,
              isFree: is_free,
              number_of_consultations: ele.number_of_consultations,
              raw_amount: ele.amount,
              value: {
                id: ele.id,
                isFree: is_free,
              },
            });
          });
        }
      }
    }
    else {
      data = [];
    }
    this.consultationWorkflowData.consultation_data.other_data.nutritionHealthCons.plans.plans_list = data;
  }

  renderAmount(amount: number | string, currency_type: string) {
    return this.utilitiesService.getRenderedAmount(Number(amount), currency_type);
  }
  closeedit() {
    this.consultationWorkflowData.edit_phone_no = false
  }

  async translatePage(event: Event) {
    const selectedLangCode = (event.target as HTMLSelectElement).value;
    this.selectedLanguage = selectedLangCode; // Update selected language
    localStorage.setItem('selectedLanguageClient', selectedLangCode); // Save to localStorage
    this.translateService.setGoogleTranslateLanguage(selectedLangCode);
    this.languageService.setLanguage(selectedLangCode);

    // Update notranslate class based on the selected language
    if (selectedLangCode === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }

  initializeLanguage() {
    const savedLanguage = localStorage.getItem('selectedLanguageClient') || 'en';
    this.selectedLanguage = savedLanguage;
    this.translateService.setGoogleTranslateLanguage(savedLanguage);

    // Update notranslate class based on the saved language
    if (savedLanguage === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
